<template>
  <v-flex xs12>
    <v-card v-if="isAdmin">
      <v-card-text>
        <v-list two-line>
          <template v-for="(item, key, index) in natOrgs">
            <v-list-tile :key="key" :to="{name:'National Organization Details', params: {id:key}}">
              <v-list-tile-content>
                <v-list-tile-title v-html="item.name"></v-list-tile-title>
                <v-list-tile-sub-title v-html="item.email"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider v-if="key !== last" :key="index"/>
          </template>
        </v-list>
      </v-card-text>
      <v-card-text style="height: 50px; position: relative">
        <NatOrgForm v-bind:isNew="true"/>
      </v-card-text>
    </v-card>
    <v-card v-else>Admins Only</v-card>
  </v-flex>
</template>
<script>
import NatOrgForm from "@/components/NatOrgForm";
import { mapGetters } from "vuex";

export default {
  name: "NatOrgs",
  components: {
    NatOrgForm
  },
  created: function() {
    this.$store.dispatch("initNatOrgs");
  },
  data: () => ({
    dialog: false
  }),
  computed: {
    ...mapGetters(["isAdmin", "natOrgs"]),
    last() {
      let keys = Object.keys(this.natOrgs);
      return keys[keys.length - 1];
    }
  }
};
</script>
